import { render, staticRenderFns } from "./EditOrganizationPointOfContactModal.vue?vue&type=template&id=db2db136&"
import script from "./EditOrganizationPointOfContactModal.vue?vue&type=script&lang=ts&"
export * from "./EditOrganizationPointOfContactModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports